import { TOUR_IDS } from "@bcc/components/tour/tour-ids";
import { Button } from "@bcc/components/ui/button";
import { ClipboardList, FileSpreadsheet } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  setOrdersHeaderContainerTestId,
  setOrdersHeaderExportButtonTestId,
  setOrdersHeaderShowSummaryButtonTestId,
  setOrdersHeaderTitleTestId,
} from "./orders-header.utils";

interface OrdersHeaderProps {
  readonly canExport: boolean;
  readonly onExportCSV: () => void;
  readonly canShowSummary?: boolean;
  readonly onShowSummary?: () => void;
  readonly testId?: string;
}

export function OrdersHeader({ canExport, onExportCSV, canShowSummary = false, onShowSummary, testId }: OrdersHeaderProps) {
  const { t } = useTranslation();

  return (
    <div data-testid={testId ?? setOrdersHeaderContainerTestId()} className="flex items-center justify-between">
      <div>
        <h1 data-testid={setOrdersHeaderTitleTestId()} className="text-3xl font-bold tracking-tight text-balance">
          {t("views.orders.title")}
        </h1>
        <p className="mt-2 text-muted-foreground">{t("views.orders.description")}</p>
      </div>

      <div className="flex gap-2">
        <Button
          data-testid={setOrdersHeaderShowSummaryButtonTestId()}
          data-tour-id={TOUR_IDS.orders.showSummary}
          onClick={onShowSummary}
          variant="outline"
          className="gap-2"
          disabled={!canShowSummary}
        >
          <ClipboardList className="h-4 w-4" />
          {t("views.orders.showSummary")}
        </Button>
        <Button
          data-testid={setOrdersHeaderExportButtonTestId()}
          data-tour-id={TOUR_IDS.orders.export}
          onClick={onExportCSV}
          variant="outline"
          className="gap-2"
          disabled={!canExport}
        >
          <FileSpreadsheet className="h-4 w-4" />
          {t("views.orders.exportCsv")}
        </Button>
      </div>
    </div>
  );
}
